import { useTranslationWithPrefix } from '@hotjar/translations';
import type { Customer } from '~/subscription-management/api/common/model/customer';
import { PayPalInfo } from '~/subscription-management/components/paypal-info/PayPalInfo';
import { FlatCard, CreditCardInfo } from '../../components';

interface Props {
  paymentMethod: Customer['paymentMethod'];
}

export function PaymentDetailsReadonly({ paymentMethod }: Props): JSX.Element | null {
  const { t } = useTranslationWithPrefix('checkout:payment-details');

  if (paymentMethod.paymentMethodType === 'CREDIT_CARD') {
    return (
      <FlatCard title={t('card-payment')}>
        <CreditCardInfo creditCardDetails={paymentMethod.details} />
      </FlatCard>
    );
  }

  if (paymentMethod.paymentMethodType === 'PAYPAL') {
    return (
      <FlatCard title={t('paypal-account')}>
        <PayPalInfo paymentDetails={paymentMethod.details} />
      </FlatCard>
    );
  }

  return null;
}
